import { compose } from '@bem-react/core';
import {
    Checkbox as BaseCheckbox,
    withLinesOne,
    withSizeS,
    withThemeNormal
} from '@yandex-lego/components/Checkbox/desktop';

const Checkbox = compose(
    withLinesOne,
    withSizeS,
    withThemeNormal
)(BaseCheckbox);

export default Checkbox;
